// Validaciones del formulario de contactos (Clientes.vue).
// Límites alineados a CRM_CONTACTO: EMAIL VARCHAR2(150), TELEFONO VARCHAR2(50).

export const EMAIL_MAX = 150;
export const TELEFONO_MAX = 50;

// Local@dominio.tld: sin espacios, un solo "@", dominio con al menos un punto
// y TLD alfabético de 2+ letras. Más estricto que type="email" del navegador,
// que acepta "a@b".
const EMAIL_RE =
  /^[A-Za-z0-9.!#$%&'*+/=?^_`{|}~-]+@[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?(?:\.[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*\.[A-Za-z]{2,}$/;

// Caracteres permitidos al capturar un teléfono.
const TELEFONO_CHARS_RE = /^\+?[\d\s()-]*$/;

/** Devuelve el mensaje de error del correo, o "" si es válido (vacío = válido, es opcional). */
export function validarEmail(valor) {
  const email = (valor || "").trim();
  if (!email) return "";
  if (email.length > EMAIL_MAX) return `Máximo ${EMAIL_MAX} caracteres.`;
  if (!EMAIL_RE.test(email) || email.includes("..")) {
    return "Ingresa un correo válido (ej. nombre@empresa.com).";
  }
  return "";
}

/**
 * Devuelve el mensaje de error del teléfono, o "" si es válido (vacío = válido).
 * Acepta número nacional de 10 dígitos (MX) o internacional con "+" y
 * 10 a 15 dígitos (E.164). Se permiten espacios, guiones y paréntesis.
 */
export function validarTelefono(valor) {
  const tel = (valor || "").trim();
  if (!tel) return "";
  if (tel.length > TELEFONO_MAX) return `Máximo ${TELEFONO_MAX} caracteres.`;
  if (!TELEFONO_CHARS_RE.test(tel)) {
    return "Solo se permiten dígitos, espacios, guiones, paréntesis y un + inicial.";
  }
  const digitos = tel.replace(/\D/g, "");
  if (tel.startsWith("+")) {
    if (digitos.length < 10 || digitos.length > 15) {
      return "Un número internacional debe tener entre 10 y 15 dígitos.";
    }
  } else if (digitos.length !== 10) {
    return `El teléfono debe tener 10 dígitos (tiene ${digitos.length}).`;
  }
  return "";
}

/** Elimina en captura los caracteres que nunca son válidos en un teléfono. */
export function limpiarTelefono(valor) {
  const s = (valor || "").replace(/[^\d\s()+-]/g, "");
  // "+" solo al inicio
  return s.charAt(0) + s.slice(1).replace(/\+/g, "");
}

/** Da formato legible a un número nacional de 10 dígitos: "55 1234 5678". */
export function formatearTelefono(valor) {
  const tel = (valor || "").trim();
  if (tel.startsWith("+")) return tel;
  const d = tel.replace(/\D/g, "");
  if (d.length !== 10) return tel;
  return `${d.slice(0, 2)} ${d.slice(2, 6)} ${d.slice(6)}`;
}
